var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.329,
    height: 22,
    viewBox: "0 0 29.329 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-youtube",
    d: "M29.134,68.858a4.453,4.453,0,0,0-4.239-4.652C21.721,64.057,18.484,64,15.176,64H14.145c-3.3,0-6.543.057-9.716.206A4.463,4.463,0,0,0,.195,68.87c-.143,2.039-.2,4.078-.2,6.118s.059,4.081.195,6.124a4.468,4.468,0,0,0,4.234,4.669c3.334.155,6.755.223,10.232.218q5.225.017,10.232-.218a4.469,4.469,0,0,0,4.239-4.669c.137-2.045.2-4.085.195-6.13Q29.341,71.923,29.134,68.858ZM11.853,80.608V69.35l8.307,5.626Z",
    transform: "translate(0.006 -64)",
    fill: "#ffd536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2319fa1291feca76475505e02fded278.svg";
export { ForwardRef as ReactComponent };